import { IconSource } from "src/app/@core/components/ui/icon/icon.types";

export enum SORT_ORDER {
    ASC = 'asc',
    DESC = 'desc',
    NONE = 'none'
}
export interface TableColumn {
    field: string;
    header: string;
    type?: 'text' | 'date' | 'number' | 'boolean' | 'avatar' | 'badge' | 'actions' | 'custom';
    width?: string;
    filterable?: boolean;
    sortable?: boolean; // Add columnSortingFunction to TableConfig as well for sorting
    pipe?: string;
    pipeArgs?: any[];
    cssClass?: string;
    headerClass?: string;
    visible?: boolean;
    template?: string; // Template name for custom rendering
    editable?: boolean;
    icon?: string; // Icon to display after the header label (for editable columns)
    iconSource?: IconSource; // Icon source/library (e.g. 'lucide')
}

export interface TableAction {
    icon?: string;
    label?: string;
    tooltip?: string;
    cssClass?: string;
    visible?: (rowData: any) => boolean;
    disabled?: (rowData: any) => boolean;
    action: (rowData: any, index?: number) => void;
}

export interface TableConfig {
    tableClass?: string;
    selectable?: boolean;
    paginator?: boolean;
    rows?: number;
    rowsPerPageOptions?: number[];
    scrollable?: boolean;
    scrollHeight?: string;
    loading?: boolean;
    emptyMessage?: string;
    globalFilter?: boolean;
    exportable?: boolean;
    responsive?: boolean;
    headerClass?: string; // Custom CSS class for table headers
    columnSortingFunction?: (field: string, order: SORT_ORDER) => void; // Update the data based on the sort field and order
    isRowSelectable?: (rowData: any) => boolean; // Function to determine if a row can be selected
    selectionOnRowClick?: boolean; // When false, only checkbox click selects the row; row click does not toggle selection (e.g. for opening detail view). Default true.
} 
